import { Component, OnInit } from '@angular/core';
import { Configuration } from '../../analytics-core/interfaces/configuration.interface';
import { AnalyticsDataModel } from '../models/analytics.datamodel';

@Component({
	selector: 'app-analytics-content',
	styleUrls: ['../styles/analytics.component.css'],
	templateUrl: '../views/analytics-content.component.html'
})
export class AnalyticsContentComponent implements OnInit {
	public config: Configuration = {} as Configuration;

	constructor(private analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.config = this.analyticsDataModel.config;
	}
}
